import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableHead from '@mui/material/TableHead';

import { styled } from 'helpers';

export const TableHead = styled(MuiTableHead)`
  .MuiTableRow-root {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
  .MuiTableCell-root {
    border-bottom: 2px solid ${({ theme }) => theme.palette.grey.A100};
    color: ${({ theme }) => theme.palette.blueGrey.A600};
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.5rem;
    letter-spacing: 0.5px;
  }
`;
TableHead.displayName = 'TableHead';

export const TableBody = styled(MuiTableBody)`
  .MuiTableRow-root {
    background-color: ${({ theme }) => theme.palette.common.white};
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.palette.blue.A50};
    }

    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.blue.A50};
    }
  }

  .MuiTableCell-root {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey.A100};
    color: ${({ theme }) => theme.palette.blueGrey[900]};
  }
`;
TableBody.displayName = 'TableBody';

export const TableCell = styled(MuiTableCell)`
  height: 64px; // The display for this element is table-cell, making this property as min-height.
  padding: 8px;

  &[aria-sort='ascending'] .MuiTableSortLabel-root svg {
    transition: transform 0.2s ease;
    transform: rotate(180deg);
  }

  &:hover .MuiTableSortLabel-root {
    cursor: pointer;

    .downSolid {
      background-color: ${({ theme }) => theme.palette.blue.A50};
      color: ${({ theme }) => theme.palette.blueGrey[900]};
      outline: 2px solid ${({ theme }) => theme.palette.blue.A50};
    }
    .circleDown {
      color: #64677f;
    }
  }

  .MuiTableSortLabel-root {
    .circleDown {
      font-size: 12px;
      margin-left: 8px;
      color: ${({ theme }) => theme.palette.blueGrey[900]};
    }
    .downSolid {
      border-radius: 50%;
      font-size: 10px;
      margin-left: 10px;
      color: ${({ theme }) => theme.palette.blueGrey.A400};
    }
  }
`;
TableCell.displayName = 'TableCell';
